import { useTranslation } from "react-i18next"
import { EAppView } from "../../Enum/EAppViewType"
import { EOrderPlaceType } from "../../Enum/EOrderPlaceType"
import { ICartItem } from "../../Interfaces/ICardItem"
import { ICartSummary } from "../Helpers/CalculateCartSummary"
import { IPublicMenuTheme, isLegacyPublicMenuTheme } from "../Helpers/PublicMenuTheme"

interface ShoppingCartButtonProp {
  orderMode: EOrderPlaceType
  cart: ICartItem[]
  currentView: EAppView
  summary: ICartSummary
  setIsCartOpen: (value: boolean) => void
  theme: IPublicMenuTheme
  servicePointSelfService?: boolean
  orderingEnabled?: boolean
}

export const ShoppingCartButton = ({
  orderMode,
  cart,
  currentView,
  summary,
  setIsCartOpen,
  theme,
  servicePointSelfService = false,
  orderingEnabled = true,
}: ShoppingCartButtonProp) => {
  const { t } = useTranslation()
  const isLegacyTheme = isLegacyPublicMenuTheme(theme)
  return (
    <>
      {orderingEnabled &&
        (orderMode === EOrderPlaceType.Delivery || servicePointSelfService) &&
        cart.length > 0 &&
        currentView === EAppView.CustomerMenu && (
          <div className="fixed bottom-20 lg:bottom-10 left-1/2 -translate-x-1/2 w-full max-w-md px-3 z-[50]  animate-in slide-in-from-bottom-10 duration-500">
            <button
              onClick={() => setIsCartOpen(true)}
              className="w-full bg-white hover:bg-orange-100 text-white h-14 rounded-[0.5rem] flex items-center justify-between px-5 ring-2 ring-orange-200 hover:ring-orange-400 transition-all active:scale-95 group"
              style={
                isLegacyTheme
                  ? undefined
                  : {
                      backgroundColor: theme.cartBackgroundColor,
                      color: theme.cartTotalValueTextColor,
                      borderColor: theme.cartBorderColor,
                      boxShadow: `0 0 0 2px ${theme.cartBorderColor}`,
                    }
              }

                  data-interaction-description-key="interactionDescriptions:publicMenu.components.shoppingCartButton.button.setIsCartOpenTrue">
              <div className="flex items-center space-x-4">
                <div
                  className="bg-orange-600 w-9 h-9 rounded-xl flex items-center justify-center font-black text-sm shadow-lg animate-[pulse_1s_ease-in-out_infinite]"
                  style={
                    isLegacyTheme
                      ? undefined
                      : {
                          backgroundColor: theme.cartButtonColor,
                          color: theme.buttonTextColor,
                        }
                  }
                >
                  {cart.reduce((s, i) => s + i.quantity, 0)}
                </div>

                <div className="flex flex-col items-start leading-none">
                  <span
                    className="font-black text-[10px] uppercase tracking-[0.2em] text-orange-500 mb-0.5"
                    style={isLegacyTheme ? undefined : { color: theme.cartTitleTextColor }}
                  >
                    {t("publicMenu:cart.title")}
                  </span>

                  <span
                    className="font-black text-xs uppercase tracking-widest text-black/50"
                    style={isLegacyTheme ? undefined : { color: theme.cartDescriptionTextColor }}
                  >
                    {t("publicMenu:cart.view_items")}
                  </span>
                </div>
              </div>

              <div className="flex flex-col items-end leading-none">
                <span
                  className="text-[8px] font-black text-black/30 uppercase tracking-widest mb-1"
                  style={isLegacyTheme ? undefined : { color: theme.cartTotalLabelTextColor }}
                >
                  {t("publicMenu:cart.total")}
                </span>

                <span
                  className="font-black text-lg text-black tracking-tighter"
                  style={isLegacyTheme ? undefined : { color: theme.cartTotalValueTextColor }}
                >
                  R$ {summary.total.toFixed(2)}
                </span>
              </div>
            </button>
          </div>
        )}
    </>
  )
}
